import React from 'react';
import Navbar from './modules/Navbar';
import Hero from './modules/Hero';
import About from './modules/About';
import Prizes from './modules/Prizes';
import JudgingCriteria from './modules/JudgingCriteria';
import Timeline from './modules/Timeline';
// import Training from './modules/Training';
// import Gallery from './modules/Gallery';
// import Video from './modules/Video';
// import Register from './modules/Register';
import Partners from './modules/Partners';
import Faq from './modules/Faq';
import Contact from './modules/Contact';
import Footer from './modules/Footer';
import ScrollButton from './modules/ScrollButton';
import { Helmet } from "react-helmet";
import MessageEN from "./l10n/en_sg";
import Theme from './modules/Theme';

import './scss/App.scss';

class Application extends React.Component {
  constructor(props) {
    super(props);
    this.msg = this.props.Message;
  }
  render() {
    return (
      <div className="application">
        <Helmet
          title={this.msg.siteTitle}
          titleAttribute={{ itemprop: "name", lang: "en" }}
          meta={[
            { name: "author", content: "Shopee Singapore" },
            { name: "description", content: this.msg.siteDesc },
            { name: "robots", content: "index, follow" },
            { property: "og:title", content: this.msg.siteTitle },
            { property: "og:site_name", content: this.msg.siteTitle },
            { property: "og:type", content: "website" },
            { property: "og:url", content: this.siteURL },
            { property: "og:image", content: this.msg.siteImageURL },
            { property: "og:description", content: this.msg.siteDesc },
          ]}
          link={[
            { rel: "canonical", href: this.msg.sitURL },
          ]}
          script={[{
            type: "application/ld+json",
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Event",
              "name": this.msg.siteTitle,
              "description": this.msg.siteDesc,
              "image": this.msg.siteImageURL,
              "startDate": this.msg.seoStartdate,
              "endDate": this.msg.seoEnddate,
              "url": this.msg.siteURL,
              "Performer": this.msg.seoPerformer,
              "audience": {
                "@type": this.msg.seoAudienceType,
                "educationalRole": "Students and Professionals passionate about Data Science",
              },
              "location": {
                "@type": "Place",
                "name": this.msg.seolocationName,
                "address": this.msg.seolocationAddress,
                "hasMap": this.msg.seoHasMap,
              },
            })
          }]}
        />
      </div>
    );
  }
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: navigator.language.slice(0, 2),
    }
    this.onChildChange = this.onChildChange.bind(this);
  }
  onChildChange(v) {
    this.setState({
      lang: v,
    })
  }
  render() {
    var Message;
    switch (this.state.lang) {
      case "en-US":
      case "en":
        Message = MessageEN;
        break;
      // case "id-ID":
      // case "id":
      //   Message = MessageID;
      //   break;
      default:
        Message = MessageEN;
        break;
    }
    return (
      <div className="App">
        {/* <Modal Message={Message} /> */}
        <Application Message={Message} />
        <Navbar Message={Message} onInputChange={this.onChildChange} value={this.state.lang} />
        <ScrollButton scrollStepInPx="50" delayInMs="1.66" />
        <Hero Message={Message} />
        <About Message={Message} />
        <Timeline Message={Message} />
        <Prizes Message={Message} />
        <Theme Message={Message.theme} />
        <JudgingCriteria Message={Message} />
        {/* <Training Message={Message} />
        <Register Message={Message} />
        <Gallery Message={Message}/>
        <Video Message={Message}/> */}
        <Faq Message={Message} />
        <Partners Message={Message} />
        <Contact Message={Message} />
        <Footer Message={Message} onInputChange={this.onChildChange} value={this.state.lang} />
        {/* <h2>{this.state.lang}</h2> */}
      </div>
    );
  }
}

export default App;
